import type { ParseKeys } from 'i18next';

export enum WorkspaceMemberRole {
  admin = 'admin',
  editor = 'editor',
  viewer = 'viewer',
}

const WorkspaceRoleList = [WorkspaceMemberRole.admin, WorkspaceMemberRole.editor, WorkspaceMemberRole.viewer] as const;

export namespace WorkspaceMemberRole {
  export function getLocalStringKey(status: WorkspaceMemberRole): ParseKeys {
    switch (status) {
      case WorkspaceMemberRole.admin:
        return 'workspace.memberRole.admin';
      case WorkspaceMemberRole.editor:
        return 'workspace.memberRole.editor';
      case WorkspaceMemberRole.viewer:
        return 'workspace.memberRole.viewer';
    }
  }

  export function values(): Readonly<WorkspaceMemberRole[]> {
    return WorkspaceRoleList;
  }

  export function fromString(value: string): WorkspaceMemberRole | undefined {
    return WorkspaceRoleList.find((role) => role.toString() === value);
  }

  export function load(value: string): WorkspaceMemberRole {
    return WorkspaceMemberRole.fromString(value) || WorkspaceMemberRole.viewer;
  }

  export function dump(role: WorkspaceMemberRole): string {
    return role.toString();
  }
}
